































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import VueRouter from "vue-router";
import { Validator } from "vee-validate";
import Input from "@/shared/components/ui/Input.vue";
import ErrorSummary from "@/shared/components/ErrorSummary.vue";
import EmployerPhone from "@/employer/components/shared/EmployerPhone.vue";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";

@Component({
  components: {
    Input,
    EmployerPhone,
    ErrorSummary
  }
})
export default class EmployerSupport extends Vue {
  $router: VueRouter;
  $validator: Validator;

  portalCustomizationStore = usePortalCustomizationStore();
  isSubmitting = false;
  supportPhone = "";
  supportEmail = "";
  supportWebsite = "";

  @Prop() employerId: number;

  mounted () {
    this.onEmployerIdChanged(this.employerId);
    this.initialize();
  }

  @Watch("employerId")
  onEmployerIdChanged (employerId: number) {
    this.portalCustomizationStore.getSupportInfo({ partnerId: 0, employerId });
  }

  get submitDisabled () {
    return this.$validator.errors.any() || this.isSubmitting;
  }

  @Watch("portalCustomizationStore.isSupportInfoLoaded")
  initialize () {
    if (this.portalCustomizationStore.isSupportInfoLoaded && !this.portalCustomizationStore.supportInfo.isFallbackData) {
      this.supportPhone = this.portalCustomizationStore.supportInfo.supportPhone;
      this.supportEmail = this.portalCustomizationStore.supportInfo.supportEmail;
      this.supportWebsite = this.portalCustomizationStore.supportInfo.supportWebsite;
    }
  }

  submit () {
    this.$validator.validateAll()
        .then(isValid => {
          if (!isValid) {
            return;
          }

          this.isSubmitting = true;
          this.portalCustomizationStore.saveEmployerSupportInfo({
                employerId: this.employerId,
                supportInfo: {
                  supportEmail: this.supportEmail,
                  supportWebsite: this.supportWebsite,
                  supportPhone: this.supportPhone,
                  customFromEmail: ""
                }
              })
              .then(_ => {
                this.isSubmitting = false;
              });
        });
  }


}
